import { rem } from 'polished'

export const TRIP_LIST_MIN_WIDTH = rem(780)
export const TRIP_LIST_GRID_COLUMNS = `${rem(40)} ${rem(128)} minmax(${rem(260)}, 1fr) minmax(${rem(104)}, ${rem(128)}) minmax(${rem(104)}, ${rem(112)}) minmax(${rem(144)}, ${rem(160)})`
export const TRIP_LIST_CONTENT_GRID_COLUMNS = `minmax(${rem(260)}, 1fr) minmax(${rem(104)}, ${rem(128)}) minmax(${rem(104)}, ${rem(112)}) minmax(${rem(144)}, ${rem(160)})`
